
import { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import logo from '../../Assets/Logos/W-logo.png';
import { FaLocationDot } from "react-icons/fa6";
import toast from "react-hot-toast";
import emailjs from "@emailjs/browser";

const services = [
  {title : "Demand Forecasting ", path : "/product/demand-forecasting"},
  {title : "Inventory Intelligence ", path : "/product/inventory-intelligence"},
  {title : "EDIFAI ", path : "/product/edifai"},
  {title : "Lite TMS for SMBs", path : "/product/lite-tms"},
  {title : "IQUA", path : "/product/iqua"},
];


const Company = [
  {title : "About ", path : "/about"},
  {title : "Leadership", path : "/leadership"},
  {title : "FAQ ", path : "/faq"},
  {title : "Partner", path : "/partner"},
  {title : "Careers", path : "/career"},
];

const footerLink = [
  {title : "Privacy Policy & Terms and Conditions", path : "/termsandprivacy"},
  {title : "Contact Us", path : "/contact"},
]

const recentPosts = [
  {
    image: "https://i.natgeofe.com/k/51b2a511-e69e-4972-8957-3c016ecdfe22/united-states-flag.gif?wp=1&w=1084.125&h=488.25",
    date: "USA",
    title: "2440 Old Milton Parkway, Suite 117, Alpharetta, GA - 30009",
  },
  {
    image: "https://static.vecteezy.com/system/resources/thumbnails/010/559/541/small/illustration-of-uae-flag-vector.jpg",
    date: "UAE",
    title: "Meydan Grandstand, 6th Floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E.",
  },
  {
    image: "https://upload.wikimedia.org/wikipedia/en/thumb/4/41/Flag_of_India.svg/250px-Flag_of_India.svg.png",
    date: "INDIA",
    title: "HIG 1/5, BDA Colony, Kapilprasad, Bhubaneswar, 751002",
  },
  
];

// Social Icons
const SocialIcon = ({ children, href }) => (
  <motion.a
    href={href || "#"}
    target="_blank"
    rel="noopener noreferrer"
    whileHover={{ scale: 1.12, backgroundColor: "#3B82F6" }}
    transition={{ type: "spring", stiffness: 300, damping: 20 }}
    className="w-9 h-9 rounded-lg bg-[#1e2d42] flex items-center justify-center text-gray-300 hover:text-white transition-colors duration-200"
  >
    {children}
  </motion.a>
);

const ArrowIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" className="w-3.5 h-3.5 shrink-0 mt-0.5" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 8h10M9 4l4 4-4 4" stroke="#3B82F6" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);


const PhoneIcon = () => (
  <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 text-orange-400 shrink-0">
    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 text-orange-400 shrink-0">
    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
  </svg>
);

const currentYear = new Date().getFullYear();

const UserFooter = () => {
  const [email, setEmail] = useState("");
  const[emailerr, setEmailerr] = useState(null);
  const navigate = useNavigate();

const handleSubscribe = async () => {
  // Email Validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!email.trim()) {
    setEmailerr("Please enter your email");
    return;
  }

  if (!emailRegex.test(email)) {
    setEmailerr("Please enter a valid email");
    return;
  }

  try {
    await emailjs.send(
      "service_xccirpg",
      "template_n3tslyf",
      {
        from_name: "Newsletter Subscriber",
        from_email: email,
        contact: "Not Provided",
        company: "Not Provided",
        message: "Subscribed to newsletter",
      },
      "XkYTBlLQFelDc5Avb"
    );

    toast.success("Subscribed Successfully 🎉");

    setEmail("");
  } catch (error) {
    console.log(error);
  }
};

  return (
    <>
    <div className="relative mt-14">
      {/* ── Newsletter Banner ── */}
      <div className="w-full px-6 pt-12 absolute -top-32 md:-top-24 z-20 ">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
          className="max-w-7xl mx-auto rounded-2xl bg-[#FEB501] px-8 sm:px-14 py-7 md:py-12 flex flex-col sm:flex-row items-center justify-between gap-6 relative overflow-hidden"
        >
         
          <div className="absolute inset-0 flex items-center justify-center opacity-10 pointer-events-none">
            <svg viewBox="0 0 100 100" className="w-48 h-48 text-white" fill="none">
              <path d="M20 30 Q35 10 50 30 Q65 50 80 30" stroke="white" strokeWidth="4" strokeLinecap="round" fill="none"/>
              <path d="M20 50 Q35 30 50 50 Q65 70 80 50" stroke="white" strokeWidth="4" strokeLinecap="round" fill="none"/>
              <path d="M20 70 Q35 50 50 70 Q65 90 80 70" stroke="white" strokeWidth="4" strokeLinecap="round" fill="none"/>
            </svg>
          </div>

          <h2 className="text-white font-extrabold text-[1.6rem] sm:text-[2rem] leading-tight z-10 shrink-0">
            Subscribe To Our Newsletter
          </h2>
         <div className="w-full sm:w-auto flex-1 max-w-xl z-10">
  
  <div className="flex flex-col md:flex-row rounded-xl overflow-hidden shadow-lg border border-white/20 bg-white">
    
    <input
      type="email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Your e-mail address"
      className="flex-1 px-5 py-2.5 md:py-3.5 text-gray-700 text-[0.95rem] outline-none bg-white min-w-0"
    />

    <motion.button
      onClick={handleSubscribe}
      whileHover={{ backgroundColor: "#111827" }}
      whileTap={{ scale: 0.97 }}
      className="px-6 py-2.5 md:py-3.5 bg-gray-900 text-white font-semibold text-[0.93rem] whitespace-nowrap transition-colors duration-200"
    >
      Subscribe now
    </motion.button>
  </div>

  {emailerr && (
    <motion.p
      initial={{ opacity: 0, y: -4 }}
      animate={{ opacity: 1, y: 0 }}
      className="mt-2 ml-1 text-sm text-red-600 font-medium"
    >
      {emailerr}
    </motion.p>
  )}

</div>
        </motion.div>
        
      </div>

      {/* ── Main Footer ── */}
      <footer className="w-full bg-[#0d1b2e] pt-40 pb-0">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 pb-14">

            {/* Col 1: Brand */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className=""
            >
              <img src={logo} alt="Logo" className="h-20 w-auto object-cover" />
              <p className="text-gray-400 text-[0.88rem] leading-relaxed mt-4 mb-6">
                At KGS Technology Group, we believe in the transformative power of IT solutions
              </p>
              <div className="flex flex-col gap-3 mb-6">
                <a href="tel:+1 (770) 8383-KGS" className="flex items-center gap-2.5 text-gray-300 text-[0.88rem] hover:text-white transition-colors">
                  <PhoneIcon /> +1 (770) 8383-KGS
                </a>
                <a href="mailto:info@kgstechnologygroup.com" className="flex items-center gap-2.5 text-gray-300 text-[0.88rem] hover:text-white transition-colors">
                  <MailIcon /> info@kgstechnologygroup.com
                </a>
              </div>
              <div className="flex gap-2">
                <SocialIcon href="https://www.linkedin.com/company/techkgs/" >
                  <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-4 h-4"
                    >
                      <path d="M4.98 3.5C4.98 4.88 3.86 6 2.48 6S0 4.88 0 3.5 1.12 1 2.48 1s2.5 1.12 2.5 2.5zM0 8h5v16H0V8zm7.5 0h4.8v2.2h.1c.67-1.27 2.3-2.6 4.74-2.6C22 7.6 24 10.1 24 14v10h-5v-8.4c0-2-.04-4.6-2.8-4.6-2.8 0-3.2 2.2-3.2 4.4V24h-5V8z" />
                    </svg>
                </SocialIcon>
                <SocialIcon href="https://x.com/TechKGS">
                 <svg
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-4 h-4"
                    >
                      <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.847h-7.406l-5.8-7.584-6.64 7.584H.474l8.6-9.83L0 1.153h7.594l5.243 6.932 6.064-6.932zm-1.292 19.49h2.039L6.486 3.24H4.298l13.311 17.404z" />
                    </svg>
                </SocialIcon>
                <SocialIcon href="https://www.instagram.com/kgstechgroup?igsh=MTJwYjVlYjRxa2Nrbg==">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/></svg>
                </SocialIcon>
                <SocialIcon href="https://youtube.com/@kgstechgroup?si=0hXcreyeKse_W0M6">
                  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58a2.78 2.78 0 001.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.96A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/></svg>
                </SocialIcon>
              </div>
            </motion.div>

            {/* Col 2: Our Service */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <h3 className="text-white font-bold text-[1.05rem] mb-6">Top Products</h3>
              <ul className="flex flex-col gap-3">
                {services.map((s) => (
                  <li key={s}>
                    <button 
                    onClick={()=>{
                      navigate(`${s.path}`);
                      window.scrollTo({
                        top :0,
                        behavior :"smooth"
                      })
                    }}
                    className="flex items-center gap-2.5 text-gray-400 text-[0.88rem] hover:text-white transition-colors duration-200 group">
                      <ArrowIcon />
                      <span className="group-hover:translate-x-1 transition-transform duration-200">{s.title}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Col 3: Pay Links */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <h3 className="text-white font-bold text-[1.05rem] mb-6">Company</h3>
              <ul className="flex flex-col gap-3">
                {Company.map((s, i) => (
                  <li key={i}>
                    <button 
                      onClick={()=>{
                        navigate(`${s.path}`);
                        window.scrollTo({
                          top : 0,
                          behavior : "smooth"
                        })
                      }}
                    className="flex items-center gap-2.5 text-gray-400 text-[0.88rem] hover:text-white transition-colors duration-200 group">
                      <ArrowIcon />
                      <span className="group-hover:translate-x-1 transition-transform duration-200">{s.title}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Col 4: Contact us */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <h3 className="text-white font-bold text-[1.05rem] mb-6">Addresses</h3>
              <div className="flex flex-col gap-5">
                {recentPosts.map((post, i) => (
                  <div key={i} className="flex items-start gap-3 group">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-14 h-12 object-cover rounded-lg shrink-0"
                    />
                    <div>
                      <div className="flex items-center gap-1.5 mb-1">
                        < FaLocationDot className="text-gray-200"/>
                        <span className="text-orange-400 text-[0.78rem]">{post.date}</span>
                      </div>
                      <p className="text-white text-xs font-semibold leading-snug group-hover:text-orange-400 transition-colors duration-200">
                        {post.title}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>

          {/* ── Bottom Bar ── */}
          <div className="border-t border-[#1e3a52] py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-gray-500 text-[0.83rem]">
              © {currentYear} Kgs Technology group | All Rights Reserved.
            </p>
            <div className="flex items-center gap-5">
              {footerLink.map((item, i) => (
                <button
                  key={i}
                  onClick={()=>{
                    navigate(`${item.path}`);
                    window.scrollTo({
                      top:0,
                      behavior: "smooth"
                    });
                  }}
                  className="text-gray-400 text-[0.83rem] hover:text-white transition-colors duration-200"
                >
                  {item.title}
                </button>
              ))}
            </div>
          </div>
        </div>
      </footer>
      </div>
    </>
  );
};

export default UserFooter;